import { UsersGrid } from '../components/UsersGrid.tsx';

/** 사용자 관리 (tenant_admin): 초대 · 역할 · 상태 · break-glass · MFA 초기화 · 잠금 해제 */
export function UsersPage() { return <UsersGrid base="/users" queryKey="users-grid" invitePath="/users/invite" title="사용자" rolesPath="/users" deptsPath="/org/departments" />; }
